// tslint:disable-next-line: max-line-length
import { MedicalOrderNodeValue } from 'src/app/shared/models/medical-order/medical-order-node-value';
import { MedicalOrderRequestDto } from 'src/app/shared/models/medical-order/medical-order-request-dto.model';

import { MedicalOrderViewModel } from '../view-models/medical-order-view-model';
import { MedicalOrderChainHandler } from './medical-order-chain-handler';
import { convertOrderedServiceLines } from './medical-order-chain-helpers';

export class CreatePlainMedicalOrder extends MedicalOrderChainHandler {
  async handleRequest(medicalOrderRequestDto: MedicalOrderRequestDto, request: MedicalOrderNodeValue) {
    const medicalOrder = new MedicalOrderViewModel();
    medicalOrder.middleTexts = ['test1'];
    medicalOrder.outboundDate = new Date().toISOString();
    medicalOrder.positions = convertOrderedServiceLines(request);
    medicalOrderRequestDto.medicalOrders = [medicalOrder];
    medicalOrderRequestDto.integratedCareId = request.integratedCareId;
    medicalOrderRequestDto.to = request.to;
    medicalOrderRequestDto.correspondenceType = request.correspondenceType;
    medicalOrderRequestDto.diagnose = request.diagnose;
    medicalOrderRequestDto.startDate = request.startDate;
    medicalOrderRequestDto.endDate = request.endDate;
    medicalOrderRequestDto.serviceOrderId = request.serviceOrderId;
    medicalOrderRequestDto.templateId = request.templateId;
    medicalOrderRequestDto.patientId = request.patientId;
    return this.next.handleRequest(medicalOrderRequestDto, request);
  }
}
